<template>
    <section class="getGrowth">
        <div class=top_bg>

            <div class='done_title'  v-if='detail.status < 40 && !detail.marketingCampaignStatus'>
                活动已过期
            </div>

            <div v-if='detail.status < 40 && !detail.marketingCampaignStatus'>
                <img src='/images/growth/sorry.png' class='top_img'>
            </div>

            <div v-if='detail.status < 40 && detail.marketingCampaignStatus'>
                <img src='/images/growth/top_img.png' class='top_img'>
            </div>

            
            
            <div class='item_content' v-if='detail.status < 40 && detail.marketingCampaignStatus'>
                <img :src='detail.giftBagList[0].pic | formatImgUrl(500,500,true)' class='goods_img-panel' v-if="detail.giftBagList[0]">
                <!-- <div class='item' v-for='(item,index) in detail.giftBagList' @click='changeRadio(item.id,index)'>
                    <div class='item_check'>
                        <div class='radio_content'>
                            <radio :checked="checkId == item.id" @changeRadio='changeRadio(item.id,index)'/>
                        </div>
                        

                    </div>
                    <div class='item_dero'>
                        <div class='title'>{{item.name}}</div>
                        <div class='dero'>{{item.descr}}</div>
                    </div>

                </div> -->
                <div class='btn_content mt64'>
                    <button  class='primary mybtn' @click='submitApply()'>立即领取</button>
                </div>
            </div>


            <!-- <div class='done_title'  v-if='detail.status >= 40 && $store.state.customerId == detail.customerId'>
                恭喜你
            </div> -->



            <!-- <div class='item_content font_size' v-if='detail.status >= 40 && $store.state.customerId != detail.customerId'>
                <div style="text-align: center;">已获得礼品，在<span style="color:red" @click='$router.push({name:"couponList"})'>我的优惠券</span>中查看</div> 
                <button disabled class='primary mybtn'>已领取</button>
            </div> -->



            <!-- <div class='done_title font_size'  v-if='detail.status >= 40 && $store.state.customerId != detail.customerId'>
                很抱歉，礼品已被领取
            </div> -->

            <!-- <div class='done_dero' v-if='detail.status >= 40 && $store.state.customerId == detail.customerId'>
                获得了{{getGoods.name}}
            </div> -->

            <div class='view_content' v-if='detail.status >= 40'>
                <img :src='"https://baozheng-front-new.oss-cn-beijing.aliyuncs.com/" + getGoods.pic' class='get_img' >
                <!-- <div class='btn_content mt64'>
                    <button class='primary mybtn mt80' @click='$router.push({name:"homeIndex"})'>回到首页</button>
                </div>
                <div class='btn_content' v-if='$store.state.customerId == detail.customerId'>
                    <button class='primary mybtn mt30' @click='toLook'>查看礼品</button>
                </div> -->
                <div style="width:100%;height:50px"></div>
                <div style="text-align: center;font-size: 15px;text-align: center;margin: 10px;" >已获得礼品，会陆续打包寄出</div> 
                <button disabled class='primary mybtn'>已领取</button>
            </div>
            
            <!-- <div class='btn_content mt64' v-if='detail.status < 40 && !detail.marketingCampaignStatus'>
                <button class='primary mybtn mt80' @click='$router.push({name:"homeIndex"})'>回到首页</button>
            </div> -->
            

           
        </div>
        <section class="serviceIntroduction">
            <div class="contentItem" v-for="(item, index) in detail.contentBoList" :key="index" >
                <h3 class="f28 bold">{{item.blockName}}</h3>
                <div  v-if='item.blockPic'>
                    <img   align="middle" :key="index" style='width:100%;'  v-for='(data,index) in JSON.parse(item.showBlockPic)' :src='data'/>
                </div>
                
                <div v-if='item.blockContent' v-html="item.blockContent" class='blockContent'></div>
            </div>
        </section>
        <!-- <growth-bottom></growth-bottom> -->

        <!-- 选择地址 -->
        <van-popup position="bottom" v-model="adrShow">
            <div class="containerAdr f28">
                <div class="title">选择地址</div>
                <!-- <span @click="$router.push({ name: 'addressEdit'})">添加地址</span> -->
                <div class="close" @click="adrShow = false"></div>
                <div class="addr-container">
                    <ul>
                    <li v-for='(item,index) in adrList' :key='index' @click='adrClick(index)'>
                        <div class='li_div'>
                            <radio :checked='item.isDefault'/>
                        </div>
                        <addr-com :model='item' :selected='item.trueDefault'/>
                    </li>
                    </ul>
                </div>
            <button class="secondary" @click="$router.push({ name: 'addressEdit'})">添加地址</button>
            <button class="submit btn-black-round"  @click="submitAdr">确认</button>
            </div>
        </van-popup>
    </section>
</template>

<script>
    import growthBottom from './growthBottom'
    import myApi from '@/axios/my'
    import publicObj from '@/assets/js/public';
    import loginApi from '@/axios/login'
    import { Dialog,Toast } from 'vant';
    import wxShare from "@/assets/js/wx.share"
    export default {
        name: 'growth',
        data () {
            return {
                adrShow : false,
                code : '',
                detail : {
                    status : 10,
                    giftBagList : [],
                    marketingCampaignStatus : 1
                },
                checkId : '',
                activeIndex : '',
                adrList : [],
                getGoods : {
                    
                }
            }
        },
        components: {
            growthBottom : growthBottom
        },
        watch: {},
        computed: {

        },  
        created () {
            this.code = this.$route.query.shareCode;
            this.getCodeShare();
            this.getAdressList();
            this.readActh()
        },  
        mounted () {
 
        },
        methods: {
            formatImgUrl(url, width, height,m_fill) {
                // console.log(url)
                if (url) {
                url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
                // url = url.replace(',jpg', ",webp");
                url +=',q_80';
                if(m_fill){
                    // console.log(m_fill)
                    url = url.replace('m_lfit', "m_fill");
                }
                }
                return url
            },
            readActh(){
                const code = this.$route.query.code || publicObj.GetQueryString('code') || '';
                if (code) {
                  //  alert('有code');
                  // alert('这是CODE'+code);
                  loginApi.getAUthUrl({
                    wxAuthorizeCode: code
                  }).then(res => {
                    localStorage.setItem(publicObj.openId,res.openId);
                    localStorage.setItem(publicObj.unionId,res.unionId);
                  })
                }
            },
            toLook(){
                let type = 20;
                //根据需求跳转
                this.getGoods.awardBoList.forEach((element)=>{
                    console.log(element.awardType)
                    if(element.awardType < 20){
                        type = element.awardType
                    }
                })

                if(type == 10){
                    this.$router.push({
                        name: 'orderList',
                        params: {
                            type : 5
                        }
                    })
                }else{
                    this.$router.push({
                        name: 'myIndex',
                    })
                }
            },
            submitAdr(){
                let params = {
                // goodsIdList : this.sendBackArr
                };
                this.adrList.forEach((element)=>{
                    if(element.isDefault){
                        params.customerAddressId = element.id;
                    }
                })
                
                params.giftBagId = this.detail.giftBagList[0].id;;
                params.code = this.code;
                params.uinId = localStorage.getItem(publicObj.unionId);
                if(!params.uinId){
                    this.toAuthorize()
                }
                myApi.getShareGoods(params).then((res)=>{
                    //领取成功
                    Toast('领取成功');
                    this.getCodeShare();
                    this.adrShow = false;
                })
            },
            adrClick(index){
                this.adrList.forEach((element,idx) => {
                    if(index == idx){
                        element.isDefault = true;
                    }else{
                        element.isDefault = false;
                    }
                });
            },
            getAdressList(){
                myApi.customerAddress({}).then((res)=>{
                    res.forEach(element=>{
                        element.trueDefault = element.isDefault;
                    })
                    this.adrList = res;
                })
            },
            toAuthorize(){
                Dialog.alert({
                    message: '未授权，请先完成授权',
                }).then(() => {
                    let params = {
                        redirectUri :  window.location.href
                    }

                    loginApi.authorizeUrl(params).then((res)=>{
                        location.replace(res);
                    })
                });
            },
            submitApply(){
                // if(!this.checkId){
                //     Toast('请选择一个礼品哦亲~');
                //     return;
                // }
                //需要判断领取的是否需要选择地址
                // let goods = this.detail.giftBagList[this.activeIndex];
                let goods = this.detail.giftBagList[0];
                if(goods.needAdress){
                    //需要地址信息
                    this.adrShow = true;

                }else{
                    //不需要地址信息
                    let params = {
        
                    };
                    // params.giftBagId = this.checkId;
                    params.giftBagId = this.detail.giftBagList[0].id;
                    params.code = this.code;
                    params.uinId = localStorage.getItem('unionId');
                    myApi.getShareGoods(params).then((res)=>{
                        if(res.code=='000001'){
                            // Toast('领取失败');
                            this.toAuthorize()
                        }else{
                            //领取成功
                            Toast('领取成功');
                            this.getCodeShare();
                            this.getAdressList();

                        }
                        
                    }).catch((e)=>{
                        this.getCodeShare();
                        this.getAdressList();
                        console.log(e)
                    })

                }

            },
            changeRadio(id,index){
                this.checkId = id;
                this.activeIndex = index;
            },
            getCodeShare(){
                myApi.getCodeShare(this.code).then((res)=>{
                    res.giftBagList.forEach(element => {
                        element.needAdress = false;
                        element.awardBoList.forEach(item => {
                            if(item.awardType == 10){
                                element.needAdress = true;
                            }
                        })
                    });
                    // res.status = 30;
                    this.detail = res;
                    if(res.giftBagBo){
                        this.getGoods = res.giftBagBo;
                    }

                    let shareBody = {
                        title : res.marketingCampaignBo.mainTitle,
                        desc : res.marketingCampaignBo.subTitle,
                        imgUrl : res.marketingCampaignBo.headImage.split('?')[0],
                        link : res.marketingCampaignBo.link + '?code=' + res
                    }
                    wxShare(shareBody).then(()=>{
                       this.show = false;
                    });
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .font_size{
        font-size: 36px!important;
    }
    .mt80{
        margin-top: 80px!important;
    }
    .mt30{
        margin-top: 30px!important;
    }
    .get_img{
        width: 100%;
        margin-top: 40px;
    }
    .done_title{
        text-align: center;
        font-size:60px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(223,88,103,1);
    }
    .done_dero{
        color:#333;
        font-size: 32px;
        text-align: center;
        margin-top: 10px;
    }
    .item_dero{
        margin-left: 70px;
    }
    .title{
        color:#3F3F3F;
        font-size: 40px;
        font-weight:600;
        margin-top: 38px;
        line-height:60px;
    }
    .dero{
        font-weight:400;
        font-size:24px;
        margin-top: 25px;
    }
    .goods_img{
        width: 164px;
        height: 164px;
        border-radius:50%; 
        margin-left: 22px;
        border: 2px solid #7edade;
    }
    .goods_img-panel{
        width:100%;
        margin: 20px 0;
    }
    .item_check{
        display: flex;
        align-items: center;
    }
    .radio_content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 20px;
        height: 232px;
    }
    .select{
        width: 32px;
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        .van-checkbox{
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .top_bg{
        background: url('/images/growth/top_bg.png') no-repeat;
        background-size: 100%; 
        
        padding-right:40px;
        padding-left:40px;
        padding-bottom:100px;
        padding-top:40px;
        .top_img{
            width: 100%;
            margin-top: 44px;
        }
        .item_content{
            padding:0 20px;
            .item{
                width: 100%;
                height: 232px;
                background: url('/images/growth/item_bg.png') no-repeat center center;
                background-size:100%; 
                margin: 35px 0;
                display: flex;

            }
        }
    }
    .mybtn{
        width: 100%;
        margin-top:10px;
    }

    .containerAdr{
        height: 860px;
        padding: 32px;
        position: relative;
        padding-bottom:60px;
        padding-top: 0px;
        .title{
        line-height: 90px;
        border-bottom:1px solid #EEEEEE;
        font-size: 28px;
        font-weight:500; 
        }
        &>span{
        position:absolute;
        right:30px;
        top:80px;
        color:#7ADFDF;
        }
        .addr-container{
        height: 700px;
        overflow-y: scroll;
        ul li{
            width: 100%;
            display: flex;
            padding-top:32px;

            // align-items: center;
        }
        }
        .close{
        width: 36px;
        height: 36px;
        position: absolute;
        top: 30px;
        right: 30px;
        background: url("/images/public/close.png") no-repeat center;
        background-size: 32px;
        }
        .secondary{
        position: absolute;
        bottom: 27px;
        right: 270px;
        }
        
        .submit{
        position: absolute;
        bottom: 20px;
        right: 30px;
        }
    }
.serviceIntroduction{
  padding-top: 48px;
  .contentItem{
    padding: 0 40px 40px;
    line-height: 40px;
    h3{
      margin-bottom: 40px;
      line-height: 40px;
      position: relative;
      &::after{
        content: '';
        width: 8px;
        height: 24px;
        background: $primary-color;
        position: absolute;
        left: -12px;
        top:6px
      }
    }
  }
  .van-collapse-item{
    img{
      width: 100%;
    }
  }
  .van-hairline--top::after{
    /*border-top-width:0;*/
    border-color: $border-color;
  }
  .van-hairline--top-bottom::after,
  .van-hairline--top-bottom::after{
    border-width: 0;
  }
  .pdb{
    padding-bottom: 240px;
  }
}
</style>
